<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="添加排班时间"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="健康管理专家姓名" prop="doctor_info">
                <el-autocomplete class="doctor_search"
                                 v-model="ruleForm.doctor_info"
                                 :fetch-suggestions="getDoctor"
                                 placeholder="请输入内容"
                                 @select="doctorSelect"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item label="排班日期" prop="visit_date">
                <el-date-picker
                    v-model="ruleForm.visit_date"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>

<!--            <el-form-item label="排班时间表" prop="half">-->
<!--                <el-carousel indicator-position="outside" arrow="never" :autoplay="false" height="180px">-->
<!--                    <el-carousel-item v-for="date_arr in visit_date_arr">-->
<!--                        <div class="visit_time_container">-->
<!--                            <div class="visit_time_box" v-for="(dat, i) in date_arr">-->
<!--                                &lt;!&ndash; 周一到周五 &ndash;&gt;-->
<!--                                <div class="visit_time time_header selected edit" @click="dateSelect($event)" v-if="i < 5">-->
<!--                                    <div>-->
<!--                                        <p>{{ dat.week }}</p>-->
<!--                                        <p>{{ dat.date }}</p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="visit_time time_am selected edit" @click="halfSelect($event)" v-if="i < 5">-->
<!--                                    <div>上午</div>-->
<!--                                </div>-->
<!--                                <div class="visit_time time_pm selected edit" @click="halfSelect($event)" v-if="i < 5">-->
<!--                                    <div>下午</div>-->
<!--                                </div>-->
<!--                                &lt;!&ndash; 周末 &ndash;&gt;-->
<!--                                <div class="visit_time time_header edit" @click="dateSelect($event)" v-if="i >= 5">-->
<!--                                    <div>-->
<!--                                        <p>{{ dat.week }}</p>-->
<!--                                        <p>{{ dat.date }}</p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="visit_time time_am edit" @click="halfSelect($event)" v-if="i >= 5">-->
<!--                                    <div>上午</div>-->
<!--                                </div>-->
<!--                                <div class="visit_time time_pm edit" @click="halfSelect($event)" v-if="i >= 5">-->
<!--                                    <div>下午</div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                        </div>-->
<!--                    </el-carousel-item>-->
<!--                </el-carousel>-->
<!--            </el-form-item>-->
            <el-form-item label="排班地址" prop="address_id">
                <el-select v-model="ruleForm.address_id"
                           placeholder="请选择排班地址"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allAddress"
                        :key="item.id"
                        :label="item.address_info"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排班时间段" prop="half">
                <el-radio-group v-model="ruleForm.half">
                    <el-radio label="上午">上午</el-radio>
                    <el-radio label="下午">下午</el-radio>
                    <el-radio label="全天">全天</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";

export default {
    created() {

    },
    mounted() {

    },
    data() {
        return {
            allRegion: [],
            allUserDoctor: [],
            allAddress:[],
            ruleForm: {
                doctor_id: "",
                visit_date:'',
                half: '全天',
                doctor_info: '',
                address_id: '',
            },
            visit_date_arr: [
                [
                    {date:"02/06", week: "周一", sel: "selected"},
                    {date:"02/07", week: "周二", sel: "selected"},
                    {date:"02/08", week: "周三", sel: "selected"},
                    {date:"02/09", week: "周四", sel: "selected"},
                    {date:"02/10", week: "周五", sel: "selected"},
                    {date:"02/11", week: "周六", sel: ""},
                    {date:"02/12", week: "周日", sel: ""},
                ],
                [
                    {date:"02/06", week: "周一", sel: "selected"},
                    {date:"02/07", week: "周二", sel: "selected"},
                    {date:"02/08", week: "周三", sel: "selected"},
                    {date:"02/09", week: "周四", sel: "selected"},
                    {date:"02/10", week: "周五", sel: "selected"},
                    {date:"02/11", week: "周六", sel: ""},
                    {date:"02/12", week: "周日", sel: ""},
                ],
                [
                    {date:"02/06", week: "周一", sel: "selected"},
                    {date:"02/07", week: "周二", sel: "selected"},
                    {date:"02/08", week: "周三", sel: "selected"},
                    {date:"02/09", week: "周四", sel: "selected"},
                    {date:"02/10", week: "周五", sel: "selected"},
                    {date:"02/11", week: "周六", sel: ""},
                    {date:"02/12", week: "周日", sel: ""},
                ],
                [
                    {date:"02/06", week: "周一", sel: "selected"},
                    {date:"02/07", week: "周二", sel: "selected"},
                    {date:"02/08", week: "周三", sel: "selected"},
                    {date:"02/09", week: "周四", sel: "selected"},
                    {date:"02/10", week: "周五", sel: "selected"},
                    {date:"02/11", week: "周六", sel: ""},
                    {date:"02/12", week: "周日", sel: ""},
                ],
            ],
            rules: {
                doctor_id: [
                    {required: true, message: "请选择健康管理专家", trigger: "blur"},
                ],
                doctor_info: [
                    {required: true, message: "请选择健康管理专家", trigger: "blur"},
                ],
                address_id: [
                    {required: true, message: "请选择坐诊地址", trigger: "blur"},
                ],
                visit_date: [
                    {required: true, message: "请选择排班日期", trigger: "blur"},
                ],
                half: [
                    {required: true, message: "请选择排班时间段", trigger: "blur"},
                ],

            },
            pickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() < Date.now() - 8.64e7;  // 当天之前不可选
                }
            },
            is_submit: false,
        };
    },
    methods: {
        // 返回上一页
        goBack() {

            window.close()
        },
        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminExpertServices',
                        'method': 'createVisits',
                        'params': {
                            doctor_id: this.ruleForm.doctor_id,
                            address_id: this.ruleForm.address_id,
                            half: this.ruleForm.half,
                            visit_date: this.ruleForm.visit_date,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '创建成功',
                            duration: 1500,
                            onClose: function () {
                                // window.history.go(-1);
                                _that.is_submit = false;
                                _that.$router.push({
                                    name: "doctorVisits",
                                    params: {}
                                });
                            }
                        });
                    }).catch(()=>{
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },
        getDoctor(key, cb) {
            if (!key) {
                cb([{"value": "请输入健康管理专家姓名关键词"}]);
                return;
            }
            if (key.indexOf('/') > -1) {
                this.prev_search = key.split('/')[2] || key.split('/')[1] || key.split('/')[0]
                key = this.prev_search
            }
            if (this.search_key == key) {
                cb([{"value": "请输入健康管理专家姓名关键词"}]);
                return;
            }
            this.search_key = key
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'searchDoctor',
                params: {
                    doctor_name: key,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }
                // this.use_doctors = res.data.data
                var doctors = res.data.data
                if (!doctors) {
                    return  cb([{"value": "没有找到健康管理专家"}]);
                }
                if (doctors) {
                    for (var i = 0; i < doctors.length; i++) {
                        doctors[i].value = `${doctors[i].hospital_name}/${doctors[i].department_name}/${doctors[i].user_name}`
                    }
                    cb(doctors);
                }

            });

        },
        doctorSelect(item) {
            this.ruleForm.doctor_id = item.user_id;
            this.ruleForm.doctor_name = item.user_name;
            this.getAddress()
        },
        getAddress() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getAddress',
                params: {
                    doctor_id: this.ruleForm.doctor_id
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allAddress = res.data.data;
            });
        },
        // 选择日期
        dateSelect(obj) {
            let class_str = obj.currentTarget.className
            if (class_str.indexOf('selected') > -1) {
                // 取消选中
                obj.currentTarget.classList.remove('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_am')[0].classList.remove('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_pm')[0].classList.remove('selected')
            } else {
                // 选中
                obj.currentTarget.classList.add('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_am')[0].classList.add('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_pm')[0].classList.add('selected')
            }
            this.getSelectDate()
        },
        // 选择上下午
        halfSelect(obj) {

            let class_str = obj.currentTarget.className
            let parent_node = obj.currentTarget.parentNode;
            let head_node = parent_node.getElementsByClassName('time_header')[0];
            let time_am = parent_node.getElementsByClassName('time_am')[0];
            let time_pm = parent_node.getElementsByClassName('time_pm')[0];
            if (class_str.indexOf('selected') > -1) {
                // 取消选中
                obj.currentTarget.classList.remove('selected')

                if (time_am.className.indexOf('selected') < 0 && time_pm.className.indexOf('selected') < 0) {
                    // 上下午都取消后自动取消日期勾选
                    head_node.classList.remove('selected')
                }
            } else {
                // 选中
                obj.currentTarget.classList.add('selected')
                if (head_node.className.indexOf('selected') < 0) {
                    head_node.classList.add('selected')
                }
            }
            this.getSelectDate()
        },
        // 获取已选择日期
        getSelectDate() {
            console.log(document.getElementsByClassName('visit_time_box').length)
        }
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}
.doctor_search {
    text-align: left;
    width: 100%;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #f9f9f9;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #f9f9f9;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.visit_time_container {
    display: flex;flex-direction: row;
    padding: 20px 20px;
    width: 100%;box-sizing: border-box;
    .visit_time_box {
        width: 13%;margin-right: 1.5%;
        box-sizing: border-box;font-size: 14px;
        .visit_time {
            &.edit{
                cursor: pointer;
                :hover{
                    background: #02a7f0;
                    color: #fff;
                    border-radius:5px;
                }
            }
            border-radius:5px;
            background: #e9e9e9;
            &.time_am{
                margin-top: 10px;
                &.edit:hover{
                    background: #ccedfc;
                    color: #02a7f0;
                    border-radius:5px;
                }
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.time_pm{
                margin-top: 5px;
                &.edit:hover{
                    background: #ccedfc;
                    color: #02a7f0;
                    border-radius:5px;
                }
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.selected {
                background: #02a7f0;
                color: #fff;
            }
            &.time_header{
                p{
                    height: 1em;
                    line-height: 1em;
                    margin-top: 0;
                    margin-bottom: 0;
                    &:first-child{
                        padding-top:7px;padding-bottom: 0;
                    }
                    &:last-child{
                        padding-top: 0;padding-bottom: 7px;
                    }
                }
            }

        }
        &:nth-child(7n+7){
            margin-right: 0;
        }
    }
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
